import React from 'react'

import {
	// BellOutlined,
	CopyOutlined,
	ForkOutlined,
    // InsuranceOutlined,
    InsuranceTwoTone,
	TeamOutlined,
	UserOutlined,
	GatewayOutlined,
	SettingOutlined,
	UnorderedListOutlined,
    CodepenOutlined,
	// SnippetsOutlined,
    AreaChartOutlined,
    PlayCircleOutlined
    // VideoCameraOutlined,
    // Thiry Party
} from '@ant-design/icons';

import { FEATURE_NAME } from '../common/features'

// Services
export const FEATURES = FEATURE_NAME

export const FEATURE_LABEL = {
    // Management
    [FEATURE_NAME.GEOFENCE_MANAGEMENT]: 'Geofence Management',
    [FEATURE_NAME.USER_MANAGEMENT]: "User Management",
    [FEATURE_NAME.OVERALL_MANAGEMENT]: 'Overall Management',
    // Highway Surveillance Management
    // [FEATURE_NAME.HIGHWAY_SURVEILLANCE_MANAGEMENT]: 'Highway Surveillance Management',
    // Maintenance Management
    [FEATURE_NAME.OVERALL_MAINTENANCE_MANAGEMENT]: "Overall Maintenance Management",
    // VAM
    [FEATURE_NAME.OVERALL_VEHICLE_ADVANCE_MAINTENANCE]: "Vehicle Maintenance Management",
    [FEATURE_NAME.FUEL_ANALYSIS_DASHBOARD]: "Fuel Analysis Dashboard",
    //Report
    [FEATURE_NAME.REPORT_MANAGEMENT]: 'Report',
    // [FEATURE_NAME.ESCALATION_CALL_REPORT]: "Escalation Call Report",
    // [FEATURE_NAME.FUEL_ANALYSIS_DASHBOARD]: 'Fuel Analysis Dashboard',
    [FEATURE_NAME.VEHICLE_OVERALL_REPORT]: 'Vehicle Overall Report',
    [FEATURE_NAME.DRIVER_REPORT]: 'Driver Report',
    [FEATURE_NAME.DEVICE_REPORT]: 'Device Report',
    // App Info
    [FEATURE_NAME.VEHICLE_INFORMATION_PANEL]: 'Vehicle Information Panel',
    [FEATURE_NAME.VEHICLE_ROUTE_PLAYBACK]: 'Vehicle Route Playback',
    [FEATURE_NAME.VIDEO_ROUTE_PLAYBACK]: 'Video Playback',
    // [FEATURE_NAME.VEHICLE_EVENT_TRACE]: 'Vehicle Event Trace',
    [FEATURE_NAME.USER_PROFILE]: 'User Profile',
    // Third Party
    [FEATURE_NAME.GREENER_WHEELS]: 'Greener Wheels'
}

const MENU_ICON_SIZE = 24

const MENU_COMPONENT_ITEM = (menu) => (
    {
        key: menu.feature,
        icon: (menu.icon && <menu.icon style={{ fontSize: MENU_ICON_SIZE }} />) || null,
        label: FEATURE_LABEL[menu.feature],
        feature: menu.feature,
        children: (menu.children && menu.children.map((m) => MENU_COMPONENT_ITEM(m))) || null,
    }
)

export const FEATURE_MENU_ITEMS = {
    [FEATURE_NAME.VEHICLE_INFORMATION_PANEL]: {
        feature: FEATURE_NAME.VEHICLE_INFORMATION_PANEL,
        icon: UnorderedListOutlined
    },
    [FEATURE_NAME.VEHICLE_ROUTE_PLAYBACK]: {
        feature: FEATURE_NAME.VEHICLE_ROUTE_PLAYBACK,
        icon: ForkOutlined
    },
    [FEATURE_NAME.VIDEO_ROUTE_PLAYBACK]: {
        feature: FEATURE_NAME.VIDEO_ROUTE_PLAYBACK,
        icon: PlayCircleOutlined
    },
    [FEATURE_NAME.GEOFENCE_MANAGEMENT]: {
        feature: FEATURE_NAME.GEOFENCE_MANAGEMENT,
        icon: GatewayOutlined
    },
    [FEATURE_NAME.USER_MANAGEMENT]: {
        feature: FEATURE_NAME.USER_MANAGEMENT,
        icon: TeamOutlined
    },
    // [FEATURE_NAME.HIGHWAY_SURVEILLANCE_MANAGEMENT]: {
    //     feature: FEATURE_NAME.HIGHWAY_SURVEILLANCE_MANAGEMENT,
    //     icon: VideoCameraOutlined,
    // },
    [FEATURE_NAME.OVERALL_MANAGEMENT]: {
        feature: FEATURE_NAME.OVERALL_MANAGEMENT,
        icon: SettingOutlined
    },
    [FEATURE_NAME.OVERALL_VEHICLE_ADVANCE_MAINTENANCE]: {
        feature: FEATURE_NAME.OVERALL_VEHICLE_ADVANCE_MAINTENANCE,
        icon: InsuranceTwoTone
    },
    // [FEATURE_NAME.OVERALL_MAINTENANCE_MANAGEMENT]: {
    //     feature: FEATURE_NAME.OVERALL_MAINTENANCE_MANAGEMENT,
    //     icon: InsuranceOutlined
    // },
    [FEATURE_NAME.FUEL_ANALYSIS_DASHBOARD]: {
        feature: FEATURE_NAME.FUEL_ANALYSIS_DASHBOARD,
        icon: AreaChartOutlined
    },
    [FEATURE_NAME.REPORT_MANAGEMENT]: {
        feature: FEATURE_NAME.REPORT_MANAGEMENT,
        icon: CopyOutlined
    },
    [FEATURE_NAME.VEHICLE_OVERALL_REPORT]: {
        feature: FEATURE_NAME.VEHICLE_OVERALL_REPORT,
    },
    [FEATURE_NAME.DRIVER_REPORT]: {
        feature: FEATURE_NAME.DRIVER_REPORT,
    },
    [FEATURE_NAME.DEVICE_REPORT]: {
        feature: FEATURE_NAME.DEVICE_REPORT,
    },
    // Thiry Party
    [FEATURE_NAME.GREENER_WHEELS]: {
        feature: FEATURE_NAME.GREENER_WHEELS,
        icon: CodepenOutlined
    },
    [FEATURE_NAME.USER_PROFILE]: {
        feature: FEATURE_NAME.USER_PROFILE,
        icon: UserOutlined
    }
}

export const FEATURE_MENU_ITEMS_LAYER = (_, uroleid) => [
    FEATURE_MENU_ITEMS[FEATURE_NAME.VEHICLE_INFORMATION_PANEL],
    FEATURE_MENU_ITEMS[FEATURE_NAME.VEHICLE_ROUTE_PLAYBACK],
    FEATURE_MENU_ITEMS[FEATURE_NAME.VIDEO_ROUTE_PLAYBACK],
    FEATURE_MENU_ITEMS[FEATURE_NAME.GEOFENCE_MANAGEMENT],
    FEATURE_MENU_ITEMS[FEATURE_NAME.USER_MANAGEMENT],
    FEATURE_MENU_ITEMS[FEATURE_NAME.OVERALL_MANAGEMENT],
    FEATURE_MENU_ITEMS[FEATURE_NAME.FUEL_ANALYSIS_DASHBOARD],
    FEATURE_MENU_ITEMS[FEATURE_NAME.OVERALL_VEHICLE_ADVANCE_MAINTENANCE],
    // ...(access === "u#fq3oDLbs1heXYgYnAHkE9ghv4Yj2" ? FEATURE_MENU_ITEMS[FEATURE_NAME.OVERALL_MAINTENANCE_MANAGEMENT] : []),
    // FEATURE_MENU_ITEMS[FEATURE_NAME.OVERALL_MAINTENANCE_MANAGEMENT],
    {
      ...FEATURE_MENU_ITEMS[FEATURE_NAME.REPORT_MANAGEMENT],
      children: [
            FEATURE_MENU_ITEMS[FEATURE_NAME.VEHICLE_OVERALL_REPORT],
            FEATURE_MENU_ITEMS[FEATURE_NAME.DRIVER_REPORT],
            ...( 
                (uroleid || '').includes('D') || uroleid === 'A' ? 
                    [FEATURE_MENU_ITEMS[FEATURE_NAME.DEVICE_REPORT]] : [] 
            ),
      ],
    },
    FEATURE_MENU_ITEMS[FEATURE_NAME.USER_PROFILE],
];

export const FEATURE_MENU_ITEMS_COMP_LAYER = (access, uroleid) => FEATURE_MENU_ITEMS_LAYER(access, uroleid).map((menu) => MENU_COMPONENT_ITEM(menu));

